import React from 'react'

import ReactModal, { Props } from 'react-modal'
import { palette } from '@centivo/react-components'
import { createGlobalStyle, css } from 'styled-components'

export const ModalGlobalStyles = createGlobalStyle`
  .ReactModal__Body--open {
    overflow: hidden;
  }

  .ReactModal__Overlay {
    z-index: 1000;
  }

  .ReactModal__Content {
    z-index: 100;
    width: 32.5rem;
    height: max-content;
    padding: 2.5rem;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
    margin: auto;
    box-sizing: border-box;
    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return {
            boxShadow: 'none',
          }
        default:
          return {}
      }
    }}

    h2 {
      font-weight: 700;
      font-size: 2rem;
      color: ${palette.brand.purple};
      margin-bottom: 1.5rem;
    }

    > button {
      position: absolute;
      right: 1.5rem;
      top: 1.5rem;
      padding: 0.75rem;
      border-radius: 0.25rem;
      background-color: ${palette.neutral['grey-f6f7fa']};
      font-size: 1.5rem;
    }

    button[type="submit"] {
      margin-bottom: 0;
    }
  }

  .ReactModal__Content--after-open {
    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return css`
            @media ${theme.mediaQueries.desktop} {
              border: none !important;
            }
            @media ${theme.mediaQueries.tablet} {
              border: none !important;
            }
          `
        default:
          return {}
      }
    }}
  }

`

export type ModalProps = Props

export const Modal: React.FC<ModalProps> = ({ children, style, ...props }) => {
  const modalStyle = {
    overlay: {
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      ...style?.overlay,
    },
    content: {
      padding: '2.5rem',
      ...style?.content,
    },
  } as const

  return (
    <ReactModal style={modalStyle} {...props}>
      {children}
    </ReactModal>
  )
}
